import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-paste",
  "use": "svgIcon-paste-usage",
  "viewBox": "0 0 479 522",
  "content": "<symbol viewBox=\"0 0 479 522\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-paste\"><path d=\"M443.5 402h-268c-19.575 0-35.5-15.925-35.5-35.5v-331C140 15.925 155.925 0 175.5 0h268C463.075 0 479 15.925 479 35.5v331c0 19.575-15.925 35.5-35.5 35.5z\" fill=\"currentColor\" /><path d=\"M292 422.5V475H47V167h67.5v-47h-79C15.925 120 0 135.925 0 155.5v331C0 506.075 15.925 522 35.5 522h268c19.575 0 35.5-15.925 35.5-35.5v-64z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol